import React from 'react'
import { NavLink, Link } from 'react-router-dom'


export const HeroHome = ({ children, isMobile, datawelcome, urlImagen }) => {
    const anchoimg = isMobile ? '95%' : '50%'
    return (
        <div className="hero min-h-screen" style={{ backgroundImage: `url(${urlImagen})` }}>
            <div className="hero-overlay bg-opacity-50"></div>
            <div className="hero-content text-center text-neutral-content">
                <div className="max-w-md">
                    <h1 className="mb-5 text-4xl font-bold">{datawelcome[0].title}</h1>
                    <p className="mb-5 font-bold">{datawelcome[0].welcometext}</p>
                    <button className="btn bg-blue-500"><Link to="/sesiontype">
                        {datawelcome[0].buttontext}
                    </Link></button>

                </div>
            </div>
        </div>

    )
}